import { render, staticRenderFns } from "./PersonalInfoTab3.vue?vue&type=template&id=2e8079ec"
import script from "./PersonalInfoTab3.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8079ec')) {
      api.createRecord('2e8079ec', component.options)
    } else {
      api.reload('2e8079ec', component.options)
    }
    module.hot.accept("./PersonalInfoTab3.vue?vue&type=template&id=2e8079ec", function () {
      api.rerender('2e8079ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/PersonalInfoTab3.vue"
export default component.exports